import { useEffect, useState } from 'react';

import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import { textWithReferences } from 'helpers/form';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './Checkbox.module.scss';

export const Checkbox = ({
  name,
  value,
  checked,
  label,
  tooltip,
  large = false,
  align = 'center',
  textParams = {},
  validators = {},
  register = () => {},
  className,
  style,
  onClick = () => {},
  onChange = () => {},
}) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleKeyDown = event => {
    if (event.key === ' ') {
      event.preventDefault();
      const newCheckedState = !isChecked;
      setIsChecked(newCheckedState);
      onClick(newCheckedState);
      onChange(newCheckedState);
    }
  };

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <div
      style={style}
      className={cn(
        'd-flex',
        `align-items-${align}`,
        'u-padding-bottom--small',
        'u-padding-top--small',
        'checkbox-wrapper',
        { [className]: className },
      )}>
      <input
        type="checkbox"
        name={name}
        className={cn(
          isChecked ? styles.checkboxActive : styles.checkbox,
          large ? 'u-margin-top--x-small' : '',
        )}
        value={value}
        checked={isChecked}
        onKeyDown={handleKeyDown}
        onChange={e => {
          onClick(e.target.checked);
          onChange(e.target.checked);
        }}
        tabIndex={0}
        role="checkbox"
        aria-checked={isChecked}
        {...register(name, {
          ...validators,
        })}
      />
      {typeof label === 'string' ? (
        <span
          className={cn(
            large
              ? 'u-font-size-x-large u-font-weight-500 u-padding-left primary-text checkbox-label'
              : 't-small u-padding-left--small primary-text checkbox-label',
          )}
          dangerouslySetInnerHTML={{
            __html: textWithReferences(label, textParams),
          }}
        />
      ) : (
        <span
          className={cn(
            large
              ? 'u-font-size-x-large u-font-weight-500 u-padding-left primary-text checkbox-label'
              : 't-small u-padding-left--small primary-text checkbox-label',
          )}>
          {label}
        </span>
      )}
      {tooltip && (
        <OverlayTrigger placement="bottom" overlay={<Tooltip>{tooltip}</Tooltip>}>
          <span className={styles.tooltip}>
            <FeatherIcon icon="info" />
          </span>
        </OverlayTrigger>
      )}
    </div>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  checked: PropTypes.bool,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  validators: PropTypes.object,
  register: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
};
